import React from "react";
import useBreakpoint from "@amzn/meridian/use-breakpoint";
import { MOBILE_BREAKPOINT, TABLET_BREAKPOINT } from "../../shared";
import DesktopProductIndex from "src/components/pages/eligibleProduct/desktop/desktopProductIndex";
import EligibleProductMobile from "./mobile/eligibleProductMobile";
import EligibleProductTablet from "./tablet/eligibleProductTablet";

const EligibleProductIndex = () => {
  const isMobile = useBreakpoint(MOBILE_BREAKPOINT) === "smaller";
  const isTablet = useBreakpoint(TABLET_BREAKPOINT) === "smaller";

  if (isMobile) {
    return <EligibleProductMobile></EligibleProductMobile>;
  }

  if (isTablet) {
    return <EligibleProductTablet></EligibleProductTablet>;
  }

  return <DesktopProductIndex></DesktopProductIndex>;
};

export default EligibleProductIndex;
